import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const SocialMediaStrategies = () => {
  const relatedBlogs = [
   {
      id: 1,
      title: 'How to Optimize Your Medical Practice Website for Local SEO in 2026',
      image: '/images/Blog4.png',
      date: 'February 3, 2026'
    },
    {
      id: 3,
      title: 'Top 10 Social Media Marketing Strategies for Doctors in 2026',
      image:  '/images/Blog2.png',
      date: 'January 28, 2026'
    },
    {
      id: 4,
      title: 'Patient Acquisition Through Digital Marketing: A Complete Guide',
      image: '/images/Blog4.png',
      date: 'January 15, 2026'
    }
  ];

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-4 sm:px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8"
          >
            Social Media Marketing for Doctors
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Home
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <Link 
              to="/blog" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Blog
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
              Social Media Guide
            </span>
          </motion.div>
        </div>
      </section>

      {/* SECTION 1: TWO-COLUMN WITH SIDEBAR */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <div className="grid lg:grid-cols-12 gap-6 lg:gap-8">
            
            {/* LEFT SIDE - Intro Content */}
            <div className="lg:col-span-8">
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="mb-8"
              >
                <img 
                  src="/images/Blog2.png" 
                  alt="Social Media Marketing for Doctors"
                  className="w-full rounded-2xl"
                />
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#19354a] mb-6"
              >
                Top 10 Social Media Marketing Strategies for Doctors in 2026
              </motion.h1>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="flex flex-wrap items-center gap-4 text-sm text-[#19354a] mb-8 pb-6 border-b-2 border-gray-200"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                  </svg>
                  <span>Docmize Team</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Published : January 28, 2026</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Last Updated : January 28, 2026</span>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  Social media has revolutionized how doctors connect with patients, build their reputation, and grow their medical practices. In 2026, healthcare providers who master social media marketing gain a significant competitive advantage in patient acquisition, community engagement, and professional credibility. With over 4.8 billion social media users worldwide, platforms like Facebook, Instagram, LinkedIn, and TikTok offer unprecedented opportunities to reach and educate potential patients.
                </p>

                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  This comprehensive guide explores the top 10 social media marketing strategies specifically designed for doctors and healthcare providers. From content creation and patient education to compliance and community building, we'll cover proven techniques that help medical professionals establish a strong social media presence while maintaining professionalism and adhering to healthcare regulations.
                </p>
              </motion.div>

            </div>

            {/* RIGHT SIDE - Sidebar */}
            <motion.aside 
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="lg:col-span-4"
            >
              <div className="sticky top-24">
                
                <div className="bg-white rounded-2xl border-2 border-[#19354a] p-6 mb-6">
                  <h3 className="text-xl font-bold text-[#19354a] mb-6 pb-4 border-b-2 border-gray-200">
                    Categories
                  </h3>
                  <div className="space-y-2">
                    {['Web Development', 'SEO', 'Social Media', 'Web Design', 'Online Reputation Management', 'Digital Marketing', 'Video Marketing', 'Paid Advertising', 'App Development'].map((category, index) => (
                      <Link
                        key={index}
                        to="/blog"
                        className="w-full text-left px-4 py-3 rounded-lg font-medium transition-all bg-gray-50 text-gray-700 hover:bg-[#19354a] hover:text-white block"
                      >
                        <div className="flex items-center justify-between">
                          <span>{category}</span>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#19354a] to-[#0f2133] rounded-2xl p-6 text-white">
                  <h3 className="text-xl font-bold mb-4">
                    Need Social Media Help?
                  </h3>
                  <p className="text-white/80 mb-6 text-sm leading-relaxed">
                    Get expert social media marketing strategies tailored for healthcare providers.
                  </p>
                  <Link 
                    to="/contact"
                    className="block w-full text-center px-6 py-3 bg-[#39a5d3] text-white rounded-lg font-semibold hover:bg-white hover:text-[#19354a] transition-all"
                  >
                    Get Free Consultation
                  </Link>
                </div>

              </div>
            </motion.aside>

          </div>
        </div>
      </section>

      {/* SECTION 2: FULL WIDTH CONTENT */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              1. Define Your Target Audience and Platform Strategy
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Success in social media marketing begins with understanding who you want to reach and where they spend their time online. Different demographics prefer different platforms—younger patients engage more on Instagram and TikTok, while professionals and older demographics prefer Facebook and LinkedIn. Analyze your current patient demographics, consider your specialty, and identify which platforms align best with your practice goals.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Create detailed patient personas that include age ranges, health concerns, lifestyle factors, and social media habits. This information guides your content strategy, posting schedule, and platform selection. Rather than spreading yourself thin across all platforms, focus on mastering two to three channels where your target audience is most active and engaged.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              2. Create Educational and Value-Driven Content
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Educational content positions you as a trusted healthcare authority while providing genuine value to your audience. Share health tips, explain common conditions, debunk medical myths, and answer frequently asked questions. Break down complex medical concepts into easy-to-understand language that resonates with non-medical audiences. Use infographics, carousel posts, and short videos to make information more digestible and shareable.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Balance educational content with practice updates, staff spotlights, and behind-the-scenes glimpses that humanize your practice. Share patient success stories (with proper consent and HIPAA compliance), seasonal health reminders, and preventive care tips. The key is consistency—develop a content calendar that ensures regular posting while maintaining high-quality, valuable information that serves your audience's needs.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              3. Leverage Video Content and Live Sessions
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Video content generates significantly higher engagement than static posts, making it essential for modern healthcare marketing. Create short-form videos addressing common health questions, procedure explanations, wellness tips, and day-in-the-life content. Platforms like Instagram Reels, TikTok, and YouTube Shorts prioritize video content in their algorithms, offering excellent organic reach opportunities.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Host live Q&A sessions where followers can ask health questions in real-time. These interactive sessions build trust, demonstrate expertise, and create authentic connections with potential patients. Record these sessions for later use as content pieces. Ensure all video content maintains professionalism while being approachable and relatable. Invest in good lighting and clear audio to maintain quality standards that reflect your practice's credibility.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              4. Build and Engage Your Community
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Social media success isn't just about broadcasting—it's about building relationships and fostering community engagement. Respond promptly to comments, messages, and questions. Acknowledge patient reviews and testimonials. Create polls, ask questions, and encourage followers to share their experiences and concerns. This two-way communication transforms passive followers into active community members who feel connected to your practice.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Join relevant healthcare groups, participate in health awareness campaigns, and collaborate with other local health professionals. Share user-generated content (with permission) that showcases your community involvement. Celebrate health awareness months, participate in trending health topics, and position your practice as an active, caring member of your local community. Community building creates loyal patients who become advocates for your practice.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              5. Maintain HIPAA Compliance and Professional Standards
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Healthcare social media marketing requires strict adherence to HIPAA regulations and professional standards. Never share patient information without explicit written consent. Avoid posting identifiable patient photos or discussing specific cases publicly. When sharing testimonials or success stories, obtain proper authorization forms that comply with healthcare privacy laws. Train all staff members who handle social media accounts on HIPAA compliance and appropriate online communication.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Establish clear social media policies for your practice that outline acceptable content, response protocols, and escalation procedures. Maintain professional boundaries in all interactions. Avoid making specific medical diagnoses or treatment recommendations through social media—instead, encourage followers to schedule consultations for personalized medical advice. Your online presence should enhance your professional reputation, not compromise it.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              6. Utilize Paid Social Media Advertising
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              While organic reach is valuable, paid social media advertising amplifies your message to targeted audiences beyond your existing followers. Platforms like Facebook and Instagram offer sophisticated targeting options based on demographics, interests, behaviors, and geographic location. Create targeted campaigns for specific services, seasonal health initiatives, or practice announcements. Use lead generation ads to capture appointment requests directly through social platforms.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Start with modest budgets to test different ad formats, audiences, and messaging. Analyze performance metrics like cost per click, conversion rates, and return on ad spend. Retarget website visitors who haven't booked appointments. Create lookalike audiences based on your best patients. Paid advertising complements organic efforts, accelerating growth and patient acquisition while maintaining cost-effectiveness through data-driven optimization.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              7. Showcase Your Expertise and Credentials
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Establish credibility by regularly highlighting your qualifications, certifications, continuing education, and professional achievements. Share posts about attending medical conferences, completing specialized training, or earning new certifications. Explain how your advanced training benefits patients. Feature your involvement in medical research, publications, or speaking engagements. This content reinforces your expertise while building patient confidence in your qualifications.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Balance credential showcasing with humble, approachable communication. Explain complex procedures in layman's terms. Share your passion for medicine and patient care. Introduce team members and highlight their expertise as well. Creating a professional yet personable brand attracts patients seeking both competent medical care and compassionate bedside manner. Your social media presence should reflect the quality and professionalism patients experience in your office.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              8. Implement a Consistent Posting Schedule
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Consistency builds audience trust and improves algorithmic visibility. Develop a realistic posting schedule you can maintain long-term—whether that's daily, three times weekly, or another cadence that fits your practice operations. Use scheduling tools like Buffer, Hootsuite, or Meta Business Suite to plan content in advance. Batch-create content during dedicated time blocks to maintain efficiency while ensuring regular publication.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Analyze your audience insights to determine optimal posting times when your followers are most active. Mix different content types—educational posts, practice updates, patient testimonials, health tips, and team spotlights—to maintain variety and engagement. Create themed content for specific days (Wellness Wednesday, FAQ Friday) to build anticipation. Consistent posting signals reliability and professionalism while keeping your practice top-of-mind for patients.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              9. Track Analytics and Optimize Performance
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Data-driven decision making separates successful social media strategies from ineffective ones. Regularly review platform analytics to understand what content resonates with your audience. Track metrics like engagement rates, reach, follower growth, website clicks, and appointment bookings attributed to social media. Identify your best-performing posts and replicate their success. Recognize underperforming content and adjust your strategy accordingly.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Set specific, measurable goals for your social media marketing—whether increasing followers, improving engagement rates, or generating appointment bookings. Use UTM parameters to track traffic from social platforms to your website. Conduct quarterly reviews of your overall social media strategy, assessing ROI and making strategic adjustments. Testing different approaches, analyzing results, and continuously optimizing ensures your social media efforts deliver tangible business outcomes.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              10. Integrate Social Media with Overall Marketing Strategy
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Social media shouldn't exist in isolation—it should complement and amplify your comprehensive marketing strategy. Cross-promote social channels on your website, email signatures, and printed materials. Share blog posts from your website on social platforms. Promote events, webinars, or health workshops across multiple channels. Ensure consistent branding, messaging, and visual identity across all marketing touchpoints, creating a cohesive patient experience.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Coordinate social media campaigns with traditional marketing initiatives like direct mail, local advertising, or community events. Use social proof from your social channels in other marketing materials. Encourage patients to follow your social accounts during appointments. Create a seamless patient journey where social media serves as one touchpoint in a broader strategy that includes SEO, paid advertising, email marketing, and offline engagement. Integration maximizes marketing effectiveness while providing multiple opportunities for patient connection.
            </p>

            {/* FAQ SECTION */}
            <div className="mt-12 mb-12">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-8 text-center">
                Frequently Asked Questions (FAQs)
              </h2>

              <div className="space-y-4">
                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      Which social media platform is best for doctors?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    The best platform depends on your target audience and specialty. Facebook remains popular for general practitioners reaching diverse age groups. Instagram works well for visual specialties like dermatology and cosmetic procedures. LinkedIn is ideal for B2B networking and professional reputation building. Most successful doctors maintain presence on 2-3 platforms where their patients are most active.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How often should doctors post on social media?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Aim for 3-5 posts per week for optimal engagement without overwhelming your audience. Consistency matters more than frequency. Start with a manageable schedule you can maintain long-term, then increase posting frequency as you build capacity. Quality always trumps quantity—focus on valuable content rather than posting just to meet arbitrary quotas.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      Can I share before-and-after photos on social media?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Yes, but only with explicit written patient consent that complies with HIPAA regulations. Many platforms have specific rules about medical content. Always obtain proper authorization forms, ensure photos don't include identifying information beyond what patients approved, and follow platform-specific guidelines. When in doubt, consult with healthcare legal counsel.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      Should I respond to medical questions on social media?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Provide general health education but never offer specific medical diagnoses or treatment advice through social media. Respond to questions with general information and encourage individuals to schedule consultations for personalized medical advice. Include disclaimers that social media interactions don't constitute doctor-patient relationships. This protects both you and potential patients while maintaining professionalism.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How can Docmize help with my social media marketing?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Docmize specializes in healthcare social media marketing with proven strategies for medical professionals. We handle content creation, posting schedules, community management, HIPAA-compliant campaigns, paid advertising, and performance analytics. Our healthcare-focused approach ensures your social media presence builds your practice while maintaining professional standards and regulatory compliance.
                  </div>
                </details>
              </div>
            </div>

          </motion.div>
        </div>
      </section>

      {/* RELATED BLOGS SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl font-bold text-[#19354a] mb-8"
          >
            Related Blog
          </motion.h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {relatedBlogs.map((blog, index) => (
              <motion.article
                key={blog.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#19354a] mb-3 line-clamp-2">
                    {blog.title}
                  </h3>
                  <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                    <span>{blog.date}</span>
                  </div>
                  <Link 
                    to={`/blog/${blog.id}`}
                    className="inline-flex items-center gap-2 text-[#39a5d3] font-semibold hover:gap-3 transition-all"
                  >
                    Read More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SocialMediaStrategies;